import { z } from 'zod';
/**
 * TELEFONOS STATISZTIKA - egy vonal-csatorna hivasai egy idoszakban.
 *
 * Aki a csatornat latja, a statisztikat is latja, kollegankenti bontassal
 * egyutt (Adam dontese, 2026-09-23: "nem erzekeny adat").
 *
 * A napok MAGYAR ido szerint ertendok: a "ma" a budapesti nap, nem az UTC-e.
 */
export const phoneStatsQuery = z.object({
    /** YYYY-MM-DD, budapesti nap - a kezdo es a zaro nap is beleszamit. */
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** Vesszovel elvalasztott felhasznalo-azonositok; ures = mindenki. */
    users: z
        .string()
        .optional()
        .transform((value) => (value ? value.split(',').filter(Boolean) : [])),
    direction: z.enum(['all', 'inbound', 'outbound']).default('all'),
});
/** Munkaido: hetkoznap 8 es 17 kozott (budapesti ido). Ezen kivul "munkaidon kivuli". */
export const PHONE_BUSINESS_HOURS = { startHour: 8, endHour: 17 };
/** Ennyi idon belul szamit a visszahivas a nem fogadott hivasra adott valasznak. */
export const PHONE_CALLBACK_WINDOW_DAYS = 7;
//# sourceMappingURL=phone-stats.js.map